import { render, staticRenderFns } from "./AttendeesNew.vue?vue&type=template&id=c34746d6&scoped=true"
import script from "./AttendeesNew.vue?vue&type=script&lang=js"
export * from "./AttendeesNew.vue?vue&type=script&lang=js"
import style0 from "./AttendeesNew.vue?vue&type=style&index=0&id=c34746d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c34746d6",
  null
  
)

export default component.exports